<template>
    <rkm-table
        :fields="fields.tables.faas"
        :items="faas"
        hide-filters
        hide-pagination
    >
        <template v-slot:cell(actions)='{ item }'>
            <rkm-button
                @click="$emit('select', item.id)"
                color="primary"
                small
                title="Selecionar FAA."
            >
                <rkm-icon icon="check" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    computed: {
        fields() {

            return {
                tables: {
                    faas: [
                        { key: 'id', label: 'FAA' },
                        { key: 'data', label: 'Data' },
                        { key: 'actions', label: 'Ações', class: 'col-min' }
                    ]
                }
            }
        }
    },
    props: {
        faas: { type: Array, required: true }
    }
}
</script>